import { render, staticRenderFns } from "./ArticlePage.vue?vue&type=template&id=5774f913&scoped=true"
import script from "./ArticlePage.vue?vue&type=script&lang=js"
export * from "./ArticlePage.vue?vue&type=script&lang=js"
import style0 from "./ArticlePage.vue?vue&type=style&index=0&id=5774f913&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5774f913",
  null
  
)

export default component.exports